export const STEPS = ['Fill out the form', 'Book a time slot', 'Attend a demo'];
